export default function PHP_declare() {
  return (
    <div>
      <h1>PHP_declare</h1>
    </div>
  );
}
